import * as XLSX from 'xlsx';
import { toastConfig } from 'config';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { CheckSquareOutlined, InboxOutlined } from '@ant-design/icons';
import excel from 'assets/images/icons/excel.svg';
import ErrorModal from 'pages/comptroller/ErrorModal';
import { App, Button, Col, Flex, Form, Popover, Row, Upload } from 'antd';
import { useGetRecentConversationMutation } from 'store/features/api/apiSlice';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import {
	useGetAllIdentityCaseMutation,
	useGetEmployeeListByCompanyCodeMutation,
	useGetLynFormPropertyMutation,
	useGetOrgstructureListMutation,
} from 'store/features/process/processApi';

const { Dragger } = Upload;

const ProcessRoleExclUpload = ({
	processCode,
	profileData,
	processVersion,
	setShowModal: setShowCreateModal = () => {},
	setReloadTable = () => {},
}) => {
	const { message: messageApi } = App.useApp();
	const theme = useTheme();

	const [show, setShow] = useState(false);
	const [excelData, setExcelData] = useState([]);
	const [modalInfo, setModalInfo] = useState(null);
	const [excelTable, setExcelTable] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [refetchData, setRefetchData] = useState(false);
	const [existingLynProperties, setExistingLynProperties] = useState({});
	const [existingProcessNameMap, setExistingProcessNameMap] = useState([]);

	const [fileSubmitButton, setFileSubmitButton] = useState(true);
	const [existingEntityDataMap, setExistingEntityDataMap] = useState([]);
	const [existingPositionDataMap, setExistingPositionDataMap] = useState([]);

	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();
	const [GetOrgstructureList, { data: getListOrgStructure }] = useGetOrgstructureListMutation();
	const [GetQueryV3, { data: queryV3Data, isSuccess: isSuccessV3 }] = useGetRecentConversationMutation();
	const [GetEmployeeListByCompanyCode, { data: employeeList }] = useGetEmployeeListByCompanyCodeMutation();
	const [UploadBulkIdentityCase, { error: errorData, isSuccess: isBulkCaseSuccess, isError: isBulkCaseError }] = useGetAllIdentityCaseMutation();

	useEffect(() => {
		GetLynFormProperty({
			type: 'FORM',
			processVersion,
			status: 'Active',
			fieldCode: processCode,
			propertyCode: 'PROPERTY_assignType',
			companyCode: profileData?.creatorOrganizationId,
		});
	}, [refetchData]);

	useEffect(() => {
		const lynProperties = {};

		if (lynProperty?.lynProperties?.length > 0) {
			lynProperty?.lynProperties?.forEach((value) => {
				lynProperties[value?.displayName?.replaceAll(' ', '_')] = value;
			});
		}

		setExistingLynProperties(lynProperties);
	}, [lynProperty]);

	const handleSubmitExcelData = async (excelDataParam) => {
		// console.log('excelTable', excelDataParam);
		const payloadArray = [];

		for (let i = 0; i < excelDataParam.length; i++) {
			let obj = {};

			obj = {
				companyCode: profileData?.creatorOrganizationId,
				assignTypeLabel: excelDataParam[i]?.assignType?.input ?? '',
				positionCode: excelDataParam[i]?.positionCode?.output ?? '',
				assignValue: excelDataParam[i]?.positionOrEmployeeId?.input ?? '',
				// assignTypeHidden: excelDataParam[i]?.assignType?.assignTypeHidden ?? '',
				PROPERTY_assignType: excelDataParam[i]?.assignType?.propertyValue ?? '',
			};

			if (obj?.PROPERTY_assignType === 'PROPERTY_assignType_tempAssignmentByPractice') {
				obj.DATA_processRoleUsers = excelDataParam[i]?.positionOrEmployeeId?.input ?? '';
			} else if (obj?.PROPERTY_assignType === 'PROPERTY_assignType_fixedAssignmentByProcess') {
				obj.DATA_processRolePositions = excelDataParam[i]?.positionOrEmployeeId?.input ?? '';
			}

			payloadArray.push(obj);
		}

		const payload = {
			operation: 'add-bulk',
			processCode: processCode,
			suffixCode: '',
			data: payloadArray,
		};

		UploadBulkIdentityCase(payload);
	};

	const exportData = [
		{
			positionCode: '',
			assignType: '',
			positionOrEmployeeId: '',
		},
	];

	const exportExcelFile = () => {
		const ws = XLSX.utils.json_to_sheet(exportData);
		const columnWidths = [{ wch: 20 }, { wch: 20 }, { wch: 25 }];
		ws['!cols'] = columnWidths;
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'My Sheet');
		const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const blob = new Blob([wbout], { type: 'application/octet-stream' });
		const url = window.URL.createObjectURL(blob);
		const anchor = document.createElement('a');
		anchor.href = url;
		anchor.download = 'position-role-master.xlsx';
		anchor.click();
		window.URL.revokeObjectURL(url);
	};

	const columns = [
		{
			id: 'xl_row_no',
			align: 'center',
			disablePadding: true,
			label: 'Row No',
		},
		{
			id: 'layer',
			align: 'center',
			disablePadding: true,
			label: 'Process Role Name',
		},
		{
			id: 'levelName',
			align: 'center',
			disablePadding: true,
			label: 'Assignment Type',
		},
		{
			id: 'funtionName',
			align: 'center',
			disablePadding: true,
			label: 'Position ID / Employee ID',
		},
		{
			id: 'validation',
			align: 'center',
			disablePadding: true,
			label: 'Validation',
		},
	];

	const handleFileUpload = (file) => {
		const reader = new FileReader();
		reader.onload = (e) => {
			try {
				const data = e.target.result;
				const workbook = XLSX.read(data, { type: 'array' });
				const sheetName = workbook.SheetNames[0];
				const sheet = workbook.Sheets[sheetName];
				const Data = XLSX.utils.sheet_to_json(sheet);

				messageApi.success('Excel file processed successfully.');
				validateData(Data);
				setShow(true);
			} catch (error) {
				console.error('Error processing Excel file:', error);
				messageApi.error('Error processing Excel file.');
			}
		};

		reader.readAsArrayBuffer(file);
	};

	let processNameMapData = [];

	const handleProcessName = (data) => {
		let res = { input: data, output: data, message: '', statusCode: '', isIssue: '' };

		let processDetails = existingProcessNameMap?.[data];

		if (processDetails) {
			res = { input: data, output: data, message: 'Process Role Name already exists', statusCode: '501', isIssue: true };

			return res;
		}
		if (processNameMapData[data]) {
			res = { input: data, output: data, message: 'Duplicate Process Role Name', statusCode: '502', isIssue: true };
			return res;
		}

		processNameMapData[data] = data;

		return { input: data, output: data, message: 'ok', statusCode: '200', isIssue: false };
	};

	const handleAssignType = (data) => {
		let res = { input: data, output: data, message: '', statusCode: '', isIssue: '' };
		if (data === undefined || data === null || data === '') {
			res = { input: data, output: data, message: "Assignment type can't be empty", statusCode: '501', isIssue: true };

			return res;
		}

		const existingAssignTypeExisting = existingLynProperties?.[data?.replaceAll(' ', '_')];

		if (!existingAssignTypeExisting) {
			res = {
				input: data,
				output: data,
				message: 'Assignment type must be either by Process or by Practice',
				statusCode: '502',
				isIssue: true,
			};

			return res;
		}

		// const assignTypeHidden = existingAssignTypeExisting?.propertyValue === 'PROPERTY_assignType_fixedAssignmentByProcess' ? 'POSITION' : 'USER';

		return {
			input: data,
			// assignTypeHidden,
			propertyValue: existingAssignTypeExisting?.propertyValue,
			output: data,
			message: 'ok',
			statusCode: '200',
			isIssue: false,
		};
	};

	const handlePositionOrEmployeeId = (data, assignTypeExcel) => {
		let res = { input: data, output: data, message: '', statusCode: '', isIssue: '' };
		if (data === undefined || data === null || data === '') {
			res = { input: data, output: data, message: "Position ID/Employee ID can't be empty", statusCode: '501', isIssue: true };

			return res;
		}
		let assignment = assignTypeExcel?.toLowerCase() === 'fixed assignment by process' ? 'process' : 'practice';
		if (assignment === 'process') {
			if (existingEntityDataMap[data]) {
				res = { input: data, output: data, message: 'Invalid Position Id', statusCode: '503', isIssue: true };

				return res;
			}
			if (existingPositionDataMap[data] === undefined || existingPositionDataMap[data] === null || existingPositionDataMap[data] === '') {
				res = { input: data, output: data, message: "Position ID doesn't exist", statusCode: '502', isIssue: true };

				return res;
			} else {
				res = { input: data, output: data, message: 'ok', statusCode: '200', isIssue: false };

				return res;
			}
		} else if (assignment === 'practice') {
			if (existingPositionDataMap[data]) {
				res = { input: data, output: data, message: 'Invalid Employee Id', statusCode: '504', isIssue: true };

				return res;
			}
			if (existingEntityDataMap[data] === undefined || existingEntityDataMap[data] === null || existingEntityDataMap[data] === '') {
				res = { input: data, output: data, message: "Employee ID doesn't exist", statusCode: '503', isIssue: true };

				return res;
			} else {
				res = { input: data, output: data, message: 'ok', statusCode: '200', isIssue: false };

				return res;
			}
		} else {
			res = { input: data, output: data, message: 'Invalid Assignment Type', statusCode: '505', isIssue: true };

			return res;
		}
	};

	const handleValidation = (processResult, assignTypeResult, positionResult) => {
		let res = { input: '', fiels: '', output: '', message: '', statusCode: '', isIssue: '' };
		const arr = [];
		let errorCont = 0;
		if (processResult?.isIssue) {
			arr.push({
				input: processResult?.input,
				field: 'Process Role Name',
				output: processResult?.output,
				message: processResult?.message,
				statusCode: processResult?.statusCode,
				isIssue: processResult?.isIssue,
			});
			errorCont++;
		}
		if (assignTypeResult?.isIssue) {
			arr.push({
				input: assignTypeResult?.input,
				field: 'Assignment Type',
				output: assignTypeResult?.output,
				message: assignTypeResult?.message,
				statusCode: assignTypeResult?.statusCode,
				isIssue: assignTypeResult?.isIssue,
			});
			errorCont++;
		}
		if (positionResult?.isIssue) {
			arr.push({
				input: positionResult?.input,
				field: 'Position ID/Employee ID',
				output: positionResult?.output,
				message: positionResult?.message,
				statusCode: positionResult?.statusCode,
				isIssue: positionResult?.isIssue,
			});
			errorCont++;
		}
		if (errorCont > 0) {
			res = { input: arr, output: arr, message: 'Validation Error', statusCode: '506', isIssue: true };
			return res;
		} else {
			res = { input: '', output: '', message: 'ok', statusCode: '200', isIssue: false };
			return res;
		}
	};

	const validateData = (data) => {
		const defaultKeys = Object.keys(exportData[0]);

		for (let i = 0; i < data?.length; i++) {
			let obj = data[i];
			const keys = Object.keys(obj);

			for (let j = 0; j < defaultKeys?.length; j++) {
				if (!keys.includes(defaultKeys[j])) {
					data[i][defaultKeys[j]] = '';
				}
			}
		}
		setExcelData(data);
		const arr = [];
		for (let i = 0; i < data?.length; i++) {
			let hpn = handleProcessName(data[i]?.positionCode);
			let hat = handleAssignType(data[i]?.assignType);
			let hpo = handlePositionOrEmployeeId(data[i]?.positionOrEmployeeId, data[i]?.assignType);
			let hv = handleValidation(hpn, hat, hpo);

			arr.push({
				positionCode: hpn,
				assignType: hat,
				positionOrEmployeeId: hpo,
				validation: hv,
			});
		}
		for (let i = 0; i < arr?.length; i++) {
			if (arr[i]?.validation?.isIssue === true) {
				setFileSubmitButton(true);
				break;
			} else {
				setFileSubmitButton(false);
			}
		}
		setExcelTable(arr);
	};

	const handleExcelSubmit = () => {
		setModalInfo({
			head: 'Function Master',
			action: 'submit',
		});

		setShowModal(true);
		setShow(false);
	};

	useEffect(() => {
		GetQueryV3({
			companyCode: profileData?.creatorOrganizationId,
			fieldCodes: [],
			fieldValues: [],
			name: 'processRoleView_v2',
		});
	}, [profileData]);

	useEffect(() => {
		if (queryV3Data?.results?.length > 0) {
			let temp = [];

			queryV3Data?.results?.forEach((item) => {
				temp[item?.data?.positionCode] = item?.data;
			});

			setExistingProcessNameMap(temp);
		}
	}, [queryV3Data, isSuccessV3]);

	useEffect(() => {
		if (profileData) {
			GetOrgstructureList({
				companyCode: profileData?.creatorOrganizationId,
			});
			GetEmployeeListByCompanyCode({
				parentCode: profileData?.creatorOrganizationId,
			});
		}
	}, [profileData, refetchData]);

	useEffect(() => {
		if (getListOrgStructure?.lynOrgStructModelDetails?.length > 0) {
			let temp = [];

			getListOrgStructure?.lynOrgStructModelDetails?.map((item) => {
				temp[item?.positionId] = item;

				return item;
			});
			setExistingPositionDataMap(temp);
		}
		if (employeeList?.length > 0) {
			let temp = [];
			employeeList?.map((item) => {
				temp[item?.entityCode] = item;
				return item;
			});
			setExistingEntityDataMap(temp);
		}
	}, [getListOrgStructure, employeeList]);

	useEffect(() => {
		if (excelData) {
			validateData(excelData);
		}
	}, [existingEntityDataMap, existingPositionDataMap]);

	useEffect(() => {
		if (isBulkCaseSuccess) {
			// navigate(-1);
			toast.success('Success! Action completed.', toastConfig);
			setShowCreateModal(false);
			setReloadTable((prev) => !prev);
		} else if (isBulkCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isBulkCaseSuccess]);

	return (
		<Form
			name="basic"
			layout="vertical"
			labelCol={{
				span: 12,
			}}
			wrapperCol={{
				span: 24,
			}}
		>
			<Row gutter={[24, 0]}>
				<Col xs={24}>
					<p style={{ paddingLeft: '20px' }}>
						To download a demo <img src={excel} alt="excel" width={22} style={{ margin: '0 5px' }} /> file{' '}
						<Button size="small" type="dashed" onClick={exportExcelFile} style={{ color: '#1677ff', borderColor: '#1677ff' }}>
							Click Here
						</Button>
					</p>
				</Col>

				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						htmlFor="excel"
						rules={[
							{
								required: true,
							},
						]}
					>
						{!show && (
							<Dragger
								name="file"
								customRequest={({ file }) => {
									handleFileUpload(file);
								}}
								showUploadList={false}
								accept=".xlsx, .xls"
							>
								<p className="ant-upload-drag-icon">
									<InboxOutlined />
								</p>
								<p className="ant-upload-text">Click or drag Excel file to this area to upload</p>
								<p className="ant-upload-hint">Support for .xlsx and .xls files.</p>
							</Dragger>
						)}

						{show && excelData && (
							<Box>
								<TableContainer
									sx={{
										width: '100%',
										overflowX: 'auto',
										position: 'relative',
										display: 'block',
										maxWidth: '100%',
										'& td, & th': { whiteSpace: 'nowrap' },
									}}
								>
									<Table
										aria-labelledby="tableTitle"
										sx={{
											'& .MuiTableCell-root:first-of-type': {
												pl: 2,
											},
											'& .MuiTableCell-root:last-of-type': {
												pr: 3,
											},
										}}
									>
										<TableHead>
											<TableRow style={{ backgroundColor: '#e5e5e5' }}>
												{columns.map((headCell, index) => (
													<TableCell
														key={index}
														align={headCell.align || 'left'}
														padding={headCell.disablePadding ? 'none' : 'normal'}
													>
														{headCell.label === 'Row No' && (
															<img src={excel} alt="excel" width={22} style={{ marginRight: '5px' }} />
														)}{' '}
														{headCell.label}
													</TableCell>
												))}
											</TableRow>
										</TableHead>

										<TableBody>
											{excelTable?.map((processRole, index) => {
												return (
													<TableRow
														hover
														role="checkbox"
														sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
														tabIndex={-1}
														key={index}
													>
														<TableCell key={processRole?.id} align="center">
															{index + 2}
														</TableCell>
														<TableCell key={processRole?.id} align="center">
															<div
																style={{
																	border:
																		processRole?.positionCode?.isIssue && processRole?.positionCode?.input?.length
																			? '2px solid red'
																			: '',
																}}
															>
																{processRole?.positionCode?.input}
															</div>
														</TableCell>
														<TableCell key={processRole?.id} align="center">
															<div
																style={{
																	border:
																		processRole?.assignType?.isIssue && processRole?.assignType?.input?.length
																			? '2px solid red'
																			: '',
																}}
															>
																{processRole?.assignType?.input}{' '}
															</div>{' '}
														</TableCell>
														<TableCell key={processRole?.id} align="center">
															<div
																style={{
																	border:
																		processRole?.positionOrEmployeeId?.isIssue &&
																		processRole?.positionOrEmployeeId?.input?.length
																			? '2px solid red'
																			: '',
																}}
															>
																{processRole?.positionOrEmployeeId?.input}{' '}
															</div>
														</TableCell>
														<TableCell key={processRole?.id} align="center">
															{processRole?.validation?.isIssue === false ? (
																<CheckSquareOutlined
																	size="large"
																	style={{ fontSize: '20px', color: theme.palette.lynTheme.success }}
																/>
															) : (
																<>
																	<Popover
																		trigger="focus"
																		placement="topLeft"
																		content={<ErrorModal modalData={processRole?.validation?.input} />}
																	>
																		<Button
																			style={{
																				backgroundColor: theme.palette.lynTheme.delete,
																				marginRight: '10px',
																			}}
																			type="primary"
																		>
																			Show Errors
																		</Button>
																	</Popover>
																</>
															)}
														</TableCell>
													</TableRow>
												);
											})}
										</TableBody>
									</Table>
								</TableContainer>
							</Box>
						)}
					</Form.Item>
				</Col>

				<Col xs={24} sm={24} md={24} xl={24}>
					<Flex justify="flex-end" align="flex-end" style={{ marginBottom: '20px' }}>
						{show && (
							<>
								{fileSubmitButton && (
									<Button
										style={{ backgroundColor: theme.palette.lynTheme.success, marginRight: '10px' }}
										type="primary"
										onClick={(e) => {
											e.preventDefault();

											setRefetchData((prev) => !prev);
											// validateData(excelData);
										}}
									>
										Revalidate
									</Button>
								)}

								<Button
									style={{ backgroundColor: theme.palette.lynTheme.delete, marginRight: '10px' }}
									type="primary"
									onClick={(e) => {
										e.preventDefault();
										setExcelTable([]);
										setShow(false);
									}}
								>
									Cancel
								</Button>

								<Button
									disabled={fileSubmitButton}
									style={{ backgroundColor: fileSubmitButton ? '' : theme.palette.lynTheme.submit }}
									type="primary"
									onClick={(e) => {
										e.preventDefault();
										handleExcelSubmit(excelTable);
									}}
								>
									Submit
								</Button>
							</>
						)}
					</Flex>
				</Col>
			</Row>

			{showModal && (
				<ComptrollerConfirmModal
					showModal={showModal}
					setShowModal={setShowModal}
					modalData={modalInfo}
					handleSubmit={() => handleSubmitExcelData(excelTable)}
				/>
			)}
		</Form>
	);
};

export default ProcessRoleExclUpload;